'use strict';

module.exports = function isObject(x) {
	return !!x && (typeof x === 'function' || typeof x === 'object');
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/es-abstract/helpers/isObject.js
 ** module id = 54
 ** module chunks = 0
 **/